<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">Customer File</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-facebook.png" alt="Facebook">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowModalFb = true" v-if="isFBEmpty">+ Add Facebook Account</button>
							</div>
						</div>
						<!-- <div class="integration-warning" v-if="fbAccounts.length === 0">
							Kini software Ostock sementara direview oleh team Facebook, sehingga untuk mengintegrasikan akun Facebook anda ke Ostock.id harus dilakukan dengan cara manual.<br>
							Silahkan ikuti tutorial <a href="https://help.ostock.id/persiapan-integrasi-dengan-facebook/" target="_blank">https://help.ostock.id/persiapan-integrasi-dengan-facebook/</a> untuk mengintegrasikan akun Facebook anda.<br>
						</div> -->
						<integration-accounts
							:name="'Facebook Accounts'"
							:accounts="fbAccounts"
							@remove="removeIntegration">
							<template slot-scope="slotProps">
								{{ slotProps.account.account_name }} <span v-bind:class="{ 'integration-status error': !slotProps.account.is_active }">{{ isActiveLabel(slotProps.account.is_active) }}</span>
							</template>
						</integration-accounts>
					</div>
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-google.png" alt="Google">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" @click="isShowModalGoogle = true" v-if="isGoogleEmpty">+ Add Google Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Google Accounts'"
							:accounts="googleAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Facebook -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalFb" @close="isShowModalFb = false">
			<div slot="header"><h3>Facebook</h3></div>
			<div slot="body" class="text-center">
				<h5 class="modal-title">How to Integrate</h5>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/aRB9QqsIN5w?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<button class="btn btn-primary btn-lg btn-facebook" @click="connectToFacebook">
						<icon name="brands/facebook-f"></icon>Connect to Facebook
					</button>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalFb = false">{{ $t('Close') }}</button>
			</div>
		</modal>

		<!-- Google -->
		<modal class="integration-modal" :size="'medium'" v-if="isShowModalGoogle" @close="isShowModalGoogle = false">
			<div slot="header"><h3>Google Account</h3></div>
			<div slot="body" class="text-center">
				<h5 class="modal-title">How to Integrate</h5>
				<div class="integration-video embed-responsive embed-responsive-16by9">
					<iframe src="https://www.youtube.com/embed/pRw_yzgp2aA?rel=0"></iframe>
				</div>
				<div class="integration-actions">
					<a :href="googleUrl" class="btn btn-primary btn-lg">Connect to Google</a>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalGoogle = false">{{ $t('Close') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="customer_file" position="bottom right" />
</div>
</template>

<script>
// /* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import integrationApi from '../api/integration';

export default {
	name: 'settingsCustomer',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			isShowModalFb: false,
			fbResponse: false,
			isShowModalGoogle: false,
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
		}),
		onFBLoggedIn(response) {
			if (response.status === 'connected') {
				const authResponse = response.authResponse;
				const accessToken = authResponse.accessToken;
				const userID = authResponse.userID;

				const params = {
					fb_id: userID,
					fb_access_token: accessToken,
				};

				const callback = (res) => {
					this.isShowModalFb = false;
					if (res.data !== '') {
						const account = res.data;
						this.addAccount(account);

						this.$notify({
							group: 'customer_file',
							title: 'Customer File',
							text: 'Successfully Connected to Facebook',
							type: 'success',
						});
					} else {
						// eslint-disable-next-line
						console.log(data.message);
					}
				};

				integrationApi.addFacebook(params, callback);
			}
		},
		connectToFacebook() {
			const config = {
				scope: 'public_profile,email,ads_management,business_management',
				return_scopes: true,
			};
			if (window.FB) {
				window.FB.login(this.onFBLoggedIn, config);
			} else {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'FB SDK Not Loaded',
					text: 'Please refresh your browser and try again',
				});
			}
		},
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = () => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addGoogle(code) {
			const params = { auth_code: code };
			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);

					this.$notify({
						group: 'customer_file',
						title: 'Customer File',
						text: 'Successfully Connected to Google',
						type: 'success',
					});
				}
			};
			integrationApi.addGoogle(params, callback);
		},
		checkCode() {
			const urlString = window.location.href;
			const url = new URL(urlString);
			const name = url.searchParams.get('name');
			const code = url.searchParams.get('code');
			if (name !== '' && code !== '') {
				if (name === 'google') {
					this.addGoogle(code);
				}
			}
		},
		isActiveLabel(isActive) {
			const message = isActive ? '' : 'Access token expired, please remove this and reconnect your Facebook account';
			return message;
		},
	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		fbAccounts() {
			return this.accounts.filter(account => account.name === 'facebook');
		},
		googleAccounts() {
			return this.accounts.filter(account => account.name === 'google');
		},
		isFBEmpty() {
			return this.fbAccounts.length === 0;
		},
		isGoogleEmpty() {
			return this.googleAccounts.length === 0;
		},
		googleUrl() {
			const endpoint = 'https://accounts.google.com/o/oauth2/auth?response_type=code&access_type=offline';
			const clientId = '154143898643-lglqg2c381884e92tis32l0uiun4mo7r.apps.googleusercontent.com';
			const appUrl = `${window.location.protocol}//${window.location.host}`;
			const redirect = `${appUrl}/settings/customer-file/callback/google`;
			const redirectUri = decodeURIComponent(redirect);
			// const redirectUri = 'https%3A%2F%2Fdev.ostock.id%2Fsettings%2Fcustomer-file%2Fcallback%2Fgoogle';
			const scope = 'https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fcontacts%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fplus.login&approval_prompt=force';
			return `${endpoint}&client_id=${clientId}&redirect_uri=${redirectUri}&state&scope=${scope}`;
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts();
		}
		this.checkCode();
	},
};
</script>
